<!-- 老人健康数据 -->
<template>
	<div class="main">
		<a-spin :spinning="spinning" tip="加载中" :delay="100">
			<a-card class="main-card">
				<div class="health-title">
					<div v-if="!isSearch" class="title">用户个人睡眠数据</div>
					<!-- 搜索结果区域 - 移除内联样式，用类名管理 -->
					<div v-if="isSearch" class="search-result">
						<div>关于“{{ searchText }}</div>
						<div>”共搜索到</div>
						<div class="search-count">{{ total }}</div>
						<div>条记录</div>
						<div class="back-btn" @click="searchBack">
							<img src="../../assets/icon_health_data_back_icon.png" alt="" />
							<div>返回</div>
						</div>
					</div>
					<!-- 操作按钮区域 - 移除内联样式 -->
					<div v-if="!isSearch" class="operation-btns">
						<div v-if="isContainMeasure && measureReportNumModel && measureReportNumModel.showFlag" class="measure_tip">
							<img class="measure_tip-arrow" src="../../assets/icon_dean_old_healthy_icon_2.png" alt="" />
							<div class="measure_tip-item">
								<img class="measure_tip-item-img" src="../../assets/icon_dean_old_healthy_icon_1.png" alt="" />
								<span>当日已测量：</span>
								<span class="text_color">{{ measureReportNumModel.bedIdBrNum || '0' }}</span>
								<span>/{{ measureReportNumModel.bedIdNum || '0' }}</span>
							</div>
							<div class="measure_tip-line"></div>
							<div class="measure_tip-item">
								<img class="measure_tip-item-img" src="../../assets/icon_dean_old_healthy_icon_1.png" alt="" />
								<span>当日已出报告：</span>
								<span class="text_color">{{ measureReportNumModel.bedIdReportNum || '0' }}</span>
								<span>/{{ measureReportNumModel.bedIdNum || '0' }}</span>
							</div>
						</div>
						<router-link target="_blank" :to="{ path: '/dean/dataSummary', params: { id: '8' } }">
							<QlBtnA :text="'当日数据汇总'" />
						</router-link>
						<router-link target="_blank" :to="{ path: '/dean/dataView', params: { id: '8' } }">
							<QlBtnA :text="'累计数据查看'" />
						</router-link>
					</div>
				</div>
				<!-- 分割线 - 移除内联样式 -->
				<div class="divider"></div>
				<div v-if="!isSearch" class="topList">
					<div class="topleft">
						<div class="group">
							<div class="group-label">楼</div>
							<a-select 
								:class="['my-a-select', oldSelectFloorIndex != newSelectFloorIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" 
								v-model="floorVal" 
								@change="floorChange"
							>
								<a-select-option v-for="(item, index) in floorData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<div class="group">
							<div class="group-label">层</div>
							<a-select 
								:class="['my-a-select', oldSelectLayerIndex != newSelectLayerIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" 
								v-model="layerVal" 
								@change="layerChange"
							>
								<a-select-option v-for="(item, index) in layerData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<div class="group">
							<div class="group-label">房</div>
							<a-select 
								:class="['my-a-select', oldSelectRoomIndex != newSelectRoomIndex ? 'my-a-select-high-light' : 'my-a-select-normal']" 
								v-model="roomVal" 
								@change="roomChange"
							>
								<a-select-option v-for="(item, index) in roomData" :key="index">
									{{ item.name }}
								</a-select-option>
							</a-select>
						</div>
						<QlBtn :text="'筛选'" @btnClick="screen" :width="'86px'" />
					</div>
					<div class="topright">
						<div class="saiBtn">
							<!-- 搜索框 - 移除内联样式 -->
							<div 
								:class="['searchBedNameInputContent',  searchInputIsHover ? 'searchBedNameInputContent_hover': '', searchInputIsEdit ? 'searchBedNameInputContent_edit' : '']"
								@mouseenter="mouseenter" 
								@mouseleave="mouseleave"
							>
								<input
									id="healthDataSearchInput"
									class="searchBedNameInput"
									v-model="searchText"
									placeholder="请输入床位名称"
									v-on:focus="inputFocus"
									v-on:blur="inputBlur"
									autocomplete="off"
									@keyup.enter="beginSearch"
								/>
								<div 
									class="searchBedNameInputContentSearchImage"
									:style="{ cursor: searchText && searchText.length > 0 ? 'pointer' : 'unset' }" 
									@click="beginSearch"
								></div>
							</div>
							<!-- 日期选择器 - 移除内联样式 -->
							<div 
								:class="['my-select-date', selectDateType == '1' ? 'my-select-date-2' : 'my-select-date-1']"
							>
								<div class="my-select-date-input">
									<div class="my-select-date-input-text">{{ showActiveDate }}</div>
									<div class="my-select-date-input-img"></div>
								</div>
								<el-date-picker
									class="my-el-date-picker"
									v-model="activeDate"
									type="date"
									placeholder="选择日期"
									value-format="yyyy-MM-dd"
									@change="changeNewDate"
									popper-class="my-el-date-picker-popper"
									:picker-options="pickerOptions"
									:clearable="false"
								>
								</el-date-picker>
							</div>
							<!-- 时间筛选按钮 - 保留原逻辑 -->
							<div 
								v-for="(item, index) in btnList2" 
								:key="index" 
								@click="btnClickNew(item.val, activeDate, 1, item.val == 3 ? '7' : '30')"
								:title="item.placeholder" 
								class="hoverBtns on dateBtn" 
								:class="{ actives: activeType == item.val }"
							>
								{{ item.title }}
							</div>
						</div>
					</div>
				</div>
				<!-- 单人查看组件 -->
				<div class="health-list" v-show="selectValue == 2">
					<HealthList ref="healthList" />
				</div>
				<!-- 表格区域 - 替换为 el-table -->
				<div class="old_healthy_table_container" v-if="total > 0 && selectValue == 1 && healthBigData[3].enable == 1">
					<el-table
						class="old_healthy_table"
						:data="tableData" 
						border 
						:row-key="row => row.bedId"
						@sort-change="onSortChange"
						height="480px"
						style="width: 100%"
						:header-cell-style="{
							background: 'rgba(245, 247, 249, 1)',
							color:'rgba(94, 103, 121, 1)',
							fontWeight: '600'
						}"
						stripe
					>
						<el-table-column 
							v-for="column in columns"
							:key="column.dataIndex || column.key"
							:prop="column.dataIndex"
							:label="column.title"
							:width="column.width"
							:align="column.align"
							:fixed="column.fixed"
							:sortable="column.sortable"
							:sort-order="column.sortOrder"
							:resizable="false"
						>
							<template slot-scope="scope">
								<!-- 操作列特殊处理 -->
								<template v-if="column.key === 'operation'">
									<div class="operation">
										<span @click="details(scope.row)" class="tableBtn">查看</span>
										<span class="share">
											<el-popover 
												placement="bottomLeft" 
												:visible-arrow="false"
												trigger="click" 
												:value="scope.row.popoverVisible"
												popper-class="share-popover"
											>
												<div class="shareBox">
													<div id="qrCode" ref="qrCodeDiv"></div>
													<p>
														<i class="el-icon-chat-dot-round" style="color: #09bb07; font-size: 22px"></i>
														<span>微信扫一扫</span>
													</p>
												</div>
												<template #reference>
													<img src="../../assets/icon_common_share_1.png" class="imgIcon" alt="" 
														@click="shareBtn(scope.row)" />
												</template>
											</el-popover>
										</span>
									</div>
								</template>
								<!-- 数字画像列特殊处理 -->
								<template v-else-if="column.key === 'szhx'">
									<div class="operation">
										<span @click="openSee(scope.row)" class="tableBtn">查看</span>
									</div>
								</template>
								<!-- 普通数据列 -->
								<template v-else>
									{{ scope.row[column.dataIndex] }}
								</template>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 空状态 -->
				<div v-if="total == 0 && selectValue == 1 && healthBigData[3].enable == 1" class="empty-state">
					<img src="../../assets/icon_common_empty_icon_new.png" alt="" />
					<div>暂无内容</div>
				</div>
				<!-- 分页 -->
				<div class="old_healthy-pagination-container">
					<a-pagination 
						v-model="pageNum" 
						@change="pageChange" 
						:total="total" 
						:pageSize="pageSize" 
						show-less-items 
						v-if="healthBigData[3].enable == 1 && total && total > 0" 
					/>
				</div>
				<!-- 未订购提示 -->
				<div class="table-empty" v-if="healthBigData[3].enable != 1">
					暂未订购
				</div>
			</a-card>
			<!-- 查看弹窗 -->
			<Healthy ref="healthy" />
			<!-- 弹窗_数字画像 -->
			<tan_needGz_portrait ref="tan_needGz_portrait"></tan_needGz_portrait>
			<!-- 弹窗_关注老人单人详情 -->
			<tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>
			<!-- AI报告 -->
			<AiReport 
				v-if="$store.state.aiSingleReportData && $route.path.indexOf('dean/oldHealthy') >= 0" 
				:itemData="$store.state.aiSingleReportData"  
			/>
		</a-spin>
	</div>
</template>



<script>
import QRCode from 'qrcodejs2';
import Healthy from '../../component/healthy/healthy.vue';
import HealthTop from './component/healthTop';
import homeTopTwo from './component/homeTopTwo';
import HealthList from './component/healthList';
import tan_needGz_portrait from './component/tan_needGz_portrait.vue';        //弹窗_数字画像
import tan_needGz_sin from './component/tan_needGz_sin.vue';                  //弹窗_关注老人单人详情
import QlBtn from '../../component/common/qlBtn.vue'
import QlBtnA from '../../component/common/qlBtnA.vue'
import AiReport from "./aiReport.vue";


// 保留 { title: '体动指数', dataIndex: 'turnOverIndex', width: "96px", align: 'center', index: '6', sorter: (a, b) => 0 },
// 单日数据列（columns）- 最后两列固定
const columns = [
  { title: '床位', dataIndex: 'bedName', width: "350px", align: 'center', sortable: "custom", sortOrder: false, index: '0' },
  { title: '睡眠得分', dataIndex: 'score', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '1' },
  { title: '睡眠时长', dataIndex: 'sleepDuration', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '2' },
  { title: '睡眠效率', dataIndex: 'sleepEff', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '3' },
  { title: '离床时长', dataIndex: 'outBedDuration', width: "110px", align: 'center', index: '4', sortable: "custom", sortOrder: false },
  { title: '睡眠间离床次数', dataIndex: 'outBedNum', width: "145px", align: 'center', index: '5', sortable: "custom", sortOrder: false },
  // { title: '体动指数', dataIndex: 'turnOverIndex', width: "96px", align: 'center', index: '6', sortable: "custom", sortOrder: false },
  { title: '呼吸异常指数', dataIndex: 'ahi', width: "145px", align: 'center', index: '7', sortable: "custom", sortOrder: false },
  { title: '需关注的变化', dataIndex: 'followTotal', width: "145px", align: 'center', index: '8', sortable: "custom", sortOrder: false },
  // 睡眠报告（固定列）
  {
    title: '睡眠报告',
    align: 'center',
    key: 'operation',
    width: '86px',
    fixed: 'right'
  },
  // 数字画像（固定列）
  {
    title: '数字画像',
    align: 'center',
    key: 'szhx',
    width: '86px',
    fixed: 'right'
  },
];

// 多日数据列（morecolumns）- 最后一列固定
const morecolumns = [
  { title: '床位', dataIndex: 'bedName', width: '274px', align: 'center', index: '0', sortable: "custom", sortOrder: false },
  { title: '睡眠时长', dataIndex: 'sleepDuration', width: '110px', align: 'center', index: '1', sortable: "custom", sortOrder: false },
  { title: '离床时长', dataIndex: 'outBedDuration', width: '110px', align: 'center', index: '2', sortable: "custom", sortOrder: false },
  { title: '睡眠间离床次数', dataIndex: 'outBedNum', width: '145px', align: 'center', index: '3', sortable: "custom", sortOrder: false },
  // { title: '体动次数', dataIndex: 'turnOverNum', width: '96px', align: 'center', index: '4', sortable: "custom", sortOrder: false },
  { title: '需关注的变化', dataIndex: 'followTotal', width: '145px', align: 'center', index: '5', sortable: "custom", sortOrder: false },
  // 睡眠报告（固定列）
  {
    title: '睡眠报告',
    align: 'center',
    key: 'operation',
    width: '86px',
    fixed: 'right'
  },
];

export default {
	components: { Healthy, HealthTop, HealthList, homeTopTwo, tan_needGz_portrait, tan_needGz_sin, QlBtn, QlBtnA, AiReport },
	data() {
		return {
			tableSpinning: true,
			showCalendar: false,
			string: '指数<5',
			string1: '5≤指数<15',
			string2: '15≤指数<30 ',
			beginTime: '',
			endTime: '',
			columns: columns,
			pageNum: 1, // 当前页
			pageSize: 20, // 每页默认20条
			total: 0,
			tableData: [],
			floorVal: '全部', // 楼
			floorData: [], // 楼下拉框数据
			layerVal: '全部', // 层
			layerData: [], // 层下拉框数据
			roomVal: '全部', // 房间
			roomData: [], // 房间下拉框数据
			loading: false,
			spinning: true,
			btnList: [
				// 筛选列表
				{
					val: 1,
					title: '昨天',
					placeholder: '呈现昨天数据分析结果',
				},
				{
					val: 2,
					title: '前天',
					placeholder: '呈现前天数据分析结果',
				},
				{
					val: 3,
					title: '过去7天',
					placeholder: '呈现过去7天数据分析结果',
				},
				{
					val: 4,
					title: '过去30天',
					placeholder: '呈现过去30天数据分析结果',
				},
			],
			btnList2: [
				// 筛选列表
				{
					val: 3,
					title: '过去7天',
					placeholder: '呈现过去7天数据分析结果',
				},
				{
					val: 4,
					title: '过去30天',
					placeholder: '呈现过去30天数据分析结果',
				},
			],
			btnList3: [
				// 筛选列表
				{
					val: 5,
					path: 'dataSummary',
					title: '当日数据汇总',
				},
				{
					val: 6,
					path: 'dataView',
					title: '累计数据查看',
				},
			],
			activeType: 1, // 默认今天
			detailsPopup: false, // 查看弹窗状态
			popoverVisible: false,
			dataTitleList: [
				{
					name: '睡眠时长',
					img: require('../../assets/icon_SleepTime_36.png'),
					time: 10,
					num: 23,
					type: 1,
				},
				{
					name: '体动次数',
					img: require('../../assets/icon_SleepTurn_36.png'),
					num: 23,
					type: 2,
				},
				{
					name: '离床时长',
					img: require('../../assets/icon_SleepLeaveTime_36.png'),
					time: 10,
					num: 23,
					type: 1,
				},
				{
					name: '离床次数',
					img: require('../../assets/icon_SleepLeave_36.png'),
					num: 23,
					type: 2,
				},

				{
					name: '睡眠呼吸',
					img: require('../../assets/icon_SleepLeaveTime_36.png'),
					time: 10,
					num: 23,
					type: 2,
				},
			],
			myChart1: null,
			myChart2: null,
			myChart3: null,
			myChart4: null,
			myChart5: null,
			myChart6: null,
			myChart7: null,
			myChart8: null,
			myChart9: null,
			myChartAHI: null,
			detailsData: {}, // 详情单天数据
			detailsManyData: {}, // 详情多天 数据
			bedName: '', // 床名称
			sleepDetails: [], // 睡眠详情数据
			shareUrl: '', // 分享参数
			sortField: null,
			sortOrder: null,
			disabled: false,
			loading1: true,
			popoverTop: null,
			scrollTop: 0,
			selectValue: 1,
			activeDate: '',
			activeDates: [],
			healthBigData: [
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
			],
			effeDatesData: null,
			effeDates: [],
			selectDateType: '1',
			
			oldSelectFloorIndex: 0,
			oldSelectLayerIndex: 0,
			oldSelectRoomIndex: 0,

			newSelectFloorIndex: 0,
			newSelectLayerIndex: 0,
			newSelectRoomIndex: 0,
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			showActiveDate: '',


			searchText: null,
			searchInputIsHover: false,
			searchInputIsEdit: false,
			isSearch: false,



			// 新增：控制是否显示额外列的标志位
			showExtraColumns: true, 
			// 新增：columns扩展列配置
			extraColumns: [
				{ title: '血氧', dataIndex: 'dealXyVal', width: "96px", align: 'center', sortable: "custom", sortOrder: false, index: '1-1' },
				{ title: '脉率', dataIndex: 'dealMlVal', width: "96px", align: 'center', sortable: "custom", sortOrder: false, index: '1-2' },
				{ title: '血压', dataIndex: 'dealXyyVal', width: "96px", align: 'center', sortable: "custom", sortOrder: false, index: '1-3' },
				{ title: '体温', dataIndex: 'dealTwVal', width: "96px", align: 'center', sortable: "custom", sortOrder: false, index: '1-4' },
			],
			// 新增：morecolumns扩展列配置
			extraMoreColumns: [
				{ title: '最低血氧', dataIndex: 'dealMaxXyVal', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '1-1' },
				{ title: '平均脉率', dataIndex: 'dealMaxMlVal', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '1-2' },
				{ title: '最高体温', dataIndex: 'dealMaxTwVal', width: "110px", align: 'center', sortable: "custom", sortOrder: false, index: '1-3' },
				{ title: '最高收缩压', dataIndex: 'dealMaxSSVal', width: "120px", align: 'center', sortable: "custom", sortOrder: false, index: '1-4' },
				{ title: '最高舒张压', dataIndex: 'dealMaxSZVal', width: "120px", align: 'center', sortable: "custom", sortOrder: false, index: '1-5' },
			],

			isContainMeasure: false,
			measureReportNumModel: null

		};
	},
	computed: {
		// 动态生成columns（修正：同步初始排序状态）
		dynamicColumns() {
			const newColumns = [...columns];
			if (this.showExtraColumns) {
				// 插入扩展列（原逻辑不变）
				const bedIndex = newColumns.findIndex(col => col.index === '0');
				if (bedIndex > -1) {
					newColumns.splice(bedIndex + 1, 0, ...this.extraColumns);
					// 重新调整index（可选，不影响排序）
					newColumns.forEach((col, idx) => {
						if (idx > bedIndex + this.extraColumns.length) {
							col.index = (parseInt(col.index) + this.extraColumns.length).toString();
						}
					});
				}
			}

			// 关键：同步初始排序状态（默认按score降序）
			if (this.sortField === 'score' && this.sortOrder === 'descend') {
				const scoreCol = newColumns.find(col => col.dataIndex === 'score');
				if (scoreCol) scoreCol.sortOrder = 'descending'; // 匹配Element UI的order值
			}

			return newColumns;
		},

		// 动态生成morecolumns（同样同步初始排序）
		dynamicMoreColumns() {
			
			let newMoreColumns = [...morecolumns];

			// 动态列没有展示时，床位列宽度为auto撑满
			if (this.showExtraColumns == true) {
				newMoreColumns[0].width = '274px';
			} else {
				newMoreColumns[0].width = 'auto';
			}

			if (this.showExtraColumns) {
				// 插入扩展列（原逻辑不变）
				const bedIndex = newMoreColumns.findIndex(col => col.index === '0');
				if (bedIndex > -1) {
					newMoreColumns.splice(bedIndex + 1, 0, ...this.extraMoreColumns);
					newMoreColumns.forEach((col, idx) => {
						if (idx > bedIndex + this.extraMoreColumns.length) {
							col.index = (parseInt(col.index) + this.extraMoreColumns.length).toString();
						}
					});
				}
			}

			// 同步初始排序（若多日数据默认排序不同，可单独配置）
			if (this.sortField === 'score' && this.sortOrder === 'descend') {
				const scoreCol = newMoreColumns.find(col => col.dataIndex === 'score');
				if (scoreCol) scoreCol.sortOrder = 'descending';
			}

			return newMoreColumns;
		}
	},
	created() {
	},
	mounted() {
		this.getHealthBigData();
		this.getActiveDates();
		this.activeDate = this.activeDates[0];
		this.getTableData();
		// 获取楼下拉框数据
		this.$get(
			'/api/building/allBuilding',
			{},
			(res) => {
				if (res.code == 0) {
					res.data[0].id = '';
					this.floorData = res.data;
				} else {
					this.$message.error(res.msg);
					this.floorData = [];
				}
			},
			(err) => {
				console.log(err);
				// this.$message.error('服务端发生异常');
			}
		);
		this.getHealthPageV1All();
		this.getMeasureFlag();
	},
	watch: {
		activeDate(newVal,oldVal){
			if (newVal == '' || !newVal) {
				
			} else {
				this.showActiveDate = this.activeDate.slice(5, 7) + '月' + this.activeDate.slice(8) + '日'
			}
		}
	},
	methods: {
		// Element UI 表格排序事件处理
		onSortChange({ column, prop, order }) {
			console.log('排序参数：', column, prop, order);
			
			// 1. 区分单日/多日列配置
			const isSingleDay = this.activeType == '1' || this.activeType == '2';
			const columnConfig = isSingleDay ? this.dynamicColumns : this.dynamicMoreColumns;

			// 2. 重置所有列的排序状态
			columnConfig.forEach(col => {
				if (col.dataIndex !== prop) {
					col.sortOrder = false; // 其他列设为无排序
				}
			});

			// 3. 更新排序参数
			if (order === 'ascending') { // 升序
				this.sortField = this.getRealSortField(prop);
				this.sortOrder = 'ascend';
			} else if (order === 'descending') { // 降序
				this.sortField = this.getRealSortField(prop);
				this.sortOrder = 'descend';
			} else { // 默认
				this.sortField = null;
				this.sortOrder = null;
			}

			// 4. 重置页码+请求数据
			this.pageNum = 1;
			this.getTableData();
		},
		getRealSortField(prop) {
			const fieldMap = {
				// 表格列dataIndex -> 接口真实字段名
				'dealXyVal': 'oxygenSaturation',
				'dealMlVal': 'pulseRate',
				'dealXyyVal': 'systolicBloodPressure', // 血压按收缩压排序
				'dealTwVal': 'bodyTemperature',
				'dealMaxXyVal': 'oxygenSaturation',
				'dealMaxMlVal': 'pulseRate',
				'dealMaxTwVal': 'bodyTemperature',
				'dealMaxSSVal': 'systolicBloodPressure',
				'dealMaxSZVal': 'diastolicBloodPressure',
				// 其他列无需映射，直接用dataIndex（如score、sleepDuration等）
			};
			return fieldMap[prop] || prop; // 无映射则直接返回prop
		},

		// 获取测量标志位（是否包含测量功能）
    getMeasureFlag(){
      this.$get(
        'api/measure/measureFlag',
        {},
        (res) => {
          if (res.code === 0) {
            if (res.data === true) {
							this.$store.commit("changeIsContainMeasure", true);
							this.isContainMeasure = true;
							this.showExtraColumns = true;
							if (this.activeType > 2) {
								this.columns = this.dynamicMoreColumns;
							} else {
								this.columns = this.dynamicColumns;
							}
						} else {
							this.$store.commit("changeIsContainMeasure", false);
							this.isContainMeasure = false;
							this.showExtraColumns = false;
						}
          } else {
						this.$store.commit("changeIsContainMeasure", false);
						this.isContainMeasure = false;
						this.showExtraColumns = false;
            this.$message.error(res.msg);
          }
        },
        (err) => {
					this.$store.commit("changeIsContainMeasure", false);
					this.isContainMeasure = false;
					this.showExtraColumns = false;
          console.log(err);
        }
      );
    },
		// 获取当日数据汇总测量Tip数据
		getMeasureReportNum(){
			if (this.activeDate == this.getCurrentDate() && this.pageNum == 1) {
				this.$get(
					'api/measure/measureReportNum',
					{
						date: this.activeDate
					},
					(res) => {
						if (res.code === 0) {
							this.measureReportNumModel = res.data;
						} else {
							this.measureReportNumModel = null;
						}
					},
					(err) => {
						this.measureReportNumModel = null;
						console.log(err);
					}
				);
			} else {
				this.measureReportNumModel = null;
			}
    },
		searchBack() {
			this.searchInputIsHover = false;
			this.searchInputIsEdit = false;
			this.isSearch = false;
			this.searchText = "";
			this.pageNum = 1;
            this.getTableData();
		},
		beginSearch() {
			if (this.searchText && this.searchText.length > 0) {
				this.isSearch = true;
			} else {
				this.isSearch = false;
			}
			this.pageNum = 1;
            this.getTableData();
		},
		inputFocus(e) {
			console.log('===搜索框编辑中===')
			this.searchInputIsEdit = true;
		},
		inputBlur(e) {
			console.log('===搜索框取消编辑===')
			this.searchInputIsEdit = false;
		},
		mouseenter(e) {
			console.log('===hover===')
			this.searchInputIsHover = true;
		},
		mouseleave() {
			console.log('===取消hover===')
			this.searchInputIsHover = false;
		},
		openSee(data) {
			this.$refs.tan_needGz_portrait.openComponent_tan_needGz_portrait(data)
		},
		disabledDate(date) {
			let today = new Date(); //当天
			today.setFullYear(today.getFullYear() - 1);
			return (
				date > this.$moment(this.$moment(new Date()).format('YYYY-MM-DD')) ||
				date < this.$moment(this.$moment(today).format('YYYY-MM-DD'))
			);
		},
		getHealthBigData() {
			this.$post(
				'api/health-big-data/select',
				{
					tenantId: this.$getCookie('userInfo').user.tenantId,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.healthBigData = res.data;
							if (this.healthBigData[0].enable != 1) {
								this.$router.replace('/dean/home');
							} else {
							}
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		handleChange(value) {
			console.log(`selected ${value}`);
			this.selectValue = value;
			this.pageNum = 1;
			this.getTableData();
		},
		changeTotal(total, pageSize) {
			this.total = total;
			this.pageSize = pageSize;
		},
		getActiveDates() {
			var day = new Date();
			var time = day.getTime();
			for (var i = 0; i <= 365; i++) {
				var ms = 24 * 3600 * 1000 * i;
				day.setTime(parseInt(time - ms));
				var y = day.getFullYear().toString();
				var m = (day.getMonth() + 1).toString();
				if (m.length <= 1) m = '0' + m;
				var d = day.getDate().toString();
				if (d.length <= 1) d = '0' + d;
				this.activeDates[i] = y + '-' + m + '-' + d;
			}
			// console.log(this.activeDates);
		},
		changeDates(value) {
			this.btnClick(1, this.activeDates[value], 2);
		},
		panelChange(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			//console.log(ad);
			if (this.activeDates.indexOf(ad) == -1) {
				var adn = ad;
				adn = parseInt(adn.split('-').join(''));
				var adsn = this.activeDate;
				adsn = parseInt(adsn.split('-').join(''));
				if (adn > adsn) this.btnClick(1, this.activeDates[0], 2);
				else this.btnClick(1, this.activeDates[this.activeDates.length - 1], 2);
			} else {
				this.btnClick(1, ad, 2);
			}
		},
		changeDate(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			//console.log(ad);
			this.btnClick(1, ad, 2);
		},
		changeNewDate(date) {
			this.btnClick(1, date, 2, '1');
		},
		AHI() {
			return (
				<span slot="AHI">
					呼吸异常指数
					<el-popover placement="bottom" popper-class="breath-popover">
						<template >
							<p>呼吸异常指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>呼吸暂停+低通气的次数。</p>
						</template>
						<i class="el-icon-question" style="color:#08c;font-size:16px;margin:5px"></i>
					</el-popover>
				</span>
			);
		},
		AI() {
			return (
				<span slot="AHI">
					呼吸暂停指数(AI)
					<el-popover placement="bottom" popper-class="breath-popover">
						<template >
							<p>呼吸暂停指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>呼吸暂停的次数。</p>
						</template>
						<i class="el-icon-question" style="color:#08c;font-size:16px;margin:5px"></i>
					</el-popover>
				</span>
			);
		},
		HI() {
			return (
				<span slot="AHI">
					低通气指数(HI)
					<el-popover placement="bottom" popper-class="breath-popover">
						<template>
							<p>低通气指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>低通气的次数。</p>
						</template>
						<i class="el-icon-question" style="color:#08c;font-size:16px;margin:5px"></i>
					</el-popover>
				</span>
			);
		},
		getCurrentDate() {
			const now = new Date();
			const year = now.getFullYear();
			// 月份补0：如果月份<10，前面加0
			const month = String(now.getMonth() + 1).padStart(2, '0');
			// 日期补0：如果日期<10，前面加0
			const day = String(now.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		// 获取表格数据
		getTableData() {

			this.tableData = [];

			this.oldSelectFloorIndex = this.newSelectFloorIndex;
			this.oldSelectLayerIndex = this.newSelectLayerIndex;
			this.oldSelectRoomIndex = this.newSelectRoomIndex;


			var self = this;
			if (this.selectValue == 2) {
				let param = {
					pageNum: this.pageNum, // 当前页
					pageSize: 5, // 每页默认20条
					type: this.activeType, // 日期
					buildingId: this.floorVal, // 楼id
					floorId: this.layerVal == '全部' ? '' : this.layerVal, // 层id
					roomId: this.roomVal == '全部' ? '' : this.roomVal, // 房间id
					sortField: '',
					sortOrder: '',
				};
				this.$refs.healthList.getData(this.activeType, param);
				return;
			}
			this.pageSize = 20;
			var st = '';
			if (this.activeType == 1 || this.activeType == 2) st = this.activeDate;
			// else if (this.activeType == 3) st = this.activeDates[6];
			else if (this.activeType == 3) st = this.activeDates[6];
			else st = this.activeDates[29];

			let needDate;
			if (this.activeType > 1) {
				var today = new Date();
				var year = today.getFullYear();
				var month = ('0' + (today.getMonth() + 1)).slice(-2);
				var day = ('0' + today.getDate()).slice(-2);
				var date = year + '-' + month + '-' + day;
				needDate = date;
			} else {
				needDate = this.activeDate;
			}

			// 完善排序字段映射
			if (this.sortField === 'dealXyVal') {
				this.sortField = 'oxygenSaturation';
			} else if (this.sortField === 'dealMlVal') {
				this.sortField = 'pulseRate';
			} else if (this.sortField === 'dealXyyVal') {
				this.sortField = 'systolicBloodPressure'; // 血压排序使用收缩压
			} else if (this.sortField === 'dealTwVal') {
				this.sortField = 'bodyTemperature';
			} else if (this.sortField === 'dealMaxXyVal') {
				this.sortField = 'oxygenSaturation';
			} else if (this.sortField === 'dealMaxMlVal') {
				this.sortField = 'pulseRate';
			} else if (this.sortField === 'dealMaxTwVal') {
				this.sortField = 'bodyTemperature';
			} else if (this.sortField === 'dealMaxSSVal') {
				this.sortField = 'systolicBloodPressure';
			} else if (this.sortField === 'dealMaxSZVal') {
				this.sortField = 'diastolicBloodPressure';
			}

			let param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				// type: this.activeType, // 日期
				startTime: st,
				endTime: needDate,
				buildingId: (this.floorVal == '全部' || this.floorVal == 0) ? '' : this.floorData[this.floorVal].id, // 楼id
				floorId: (this.layerVal == '全部' || this.layerVal == 0) ? '' : this.layerData[this.layerVal].id, // 层id
				roomId: (this.roomVal == '全部' || this.roomVal == 0) ? '' : this.roomData[this.roomVal].id, // 房间id
				sortField: this.sortField,
				sortOrder: this.sortOrder,
			};
			if (this.searchText && this.searchText.length > 0) {
				param.bedName = this.searchText;
			}
			this.spinning = true;
			this.$get(
				'/api/health/list',
				param,
				(res) => {
					this.getMeasureReportNum();
					this.spinning = false;
					if (res.code == 0) {
						if (res.data.records) {
							res.data.records.forEach(item => {

								item.dealXyVal = this.$lodash.get(item, "oxygenSaturation", "-" ) !== null ? this.$lodash.get(item, "oxygenSaturation", "-" ) : '-';
								item.dealMlVal = this.$lodash.get(item, "pulseRate", "-" ) !== null ? this.$lodash.get(item, "pulseRate", "-" ) : '-';
								item.dealXyyVal = (this.$lodash.get(item, "systolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "systolicBloodPressure", "-" ) : '-') + '/' + (this.$lodash.get(item, "diastolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "diastolicBloodPressure", "-" ) : '-');
								if (item.dealXyyVal == '-/-') item.dealXyyVal = '-'
								item.dealTwVal = this.$lodash.get(item, "bodyTemperature", "-" ) !== null ? this.$lodash.get(item, "bodyTemperature", "-" ) : '-';

								item.dealMaxXyVal = this.$lodash.get(item, "oxygenSaturation", "-" ) !== null ? this.$lodash.get(item, "oxygenSaturation", "-" ) : '-';
								item.dealMaxMlVal = this.$lodash.get(item, "pulseRate", "-" ) !== null ? this.$lodash.get(item, "pulseRate", "-" ) : '-';
								item.dealMaxTwVal = this.$lodash.get(item, "bodyTemperature", "-" ) !== null ? this.$lodash.get(item, "bodyTemperature", "-" ) : '-';
								item.dealMaxSSVal = this.$lodash.get(item, "systolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "systolicBloodPressure", "-" ) : '-';
								item.dealMaxSZVal = this.$lodash.get(item, "diastolicBloodPressure", "-" ) !== null ? this.$lodash.get(item, "diastolicBloodPressure", "-" ) : '-';

							});


							for (var i = 0; i < res.data.records.length; i++) {
								res.data.records[i].popoverVisible = false;
								res.data.records[i].sleepDuration = res.data.records[i].sleepDuration
									? this.$formaTime(res.data.records[i].sleepDuration)
									: '--';
								res.data.records[i].deepSleepDuration = res.data.records[i].deepSleepDuration
									? this.$formaTime(res.data.records[i].deepSleepDuration)
									: '0小时0分钟';
								res.data.records[i].lightSleepDuration = res.data.records[i].lightSleepDuration
									? this.$formaTime(res.data.records[i].lightSleepDuration)
									: '0小时0分钟';
								res.data.records[i].clearSleepDuration = res.data.records[i].clearSleepDuration
									? this.$formaTime(res.data.records[i].clearSleepDuration)
									: '0小时0分钟';
								res.data.records[i].outBedDuration = res.data.records[i].outBedDuration
									? this.$formaTime(res.data.records[i].outBedDuration)
									: '0小时0分钟';
								if (res.data.records[i].ahi) {
									res.data.records[i].ahi = res.data.records[i].ahi.toFixed(2);
								}
								if (
									res.data.records[i].diagnosisResults &&
									res.data.records[i].diagnosisResults == -1
								) {
									res.data.records[i].ahi = '-';
								}

								if (res.data.records[i].sleepDuration == '--') {
									//接口新增了没有健康报告的报告，所以都显示为--
									res.data.records[i].ahi = '--';
									res.data.records[i].outBedNum = '--';
									res.data.records[i].outBedDuration = '--';
									res.data.records[i].score = '--';
									res.data.records[i].turnOverIndex = '--';
									res.data.records[i].followTotal = '--';
									res.data.records[i].szhx = '--';
									res.data.records[i].sleepEff = '--';
								}
								if (res.data.records[i] && !res.data.records[i].followTotal && res.data.records[i].followTotal !== 0) {
									res.data.records[i].followTotal = '--';
								}
								if (res.data.records[i] && !res.data.records[i].turnOverNum && res.data.records[i].turnOverNum !== 0) {
									res.data.records[i].turnOverNum = '--';
								}
							}
							this.tableData = res.data.records;
							this.total = res.data.total;
						} else {
							this.tableData = [];
							this.total = 0;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.spinning = true;
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 分页
		pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getTableData();
		},
		// 监听楼选择
		floorChange(e) {
			this.newSelectFloorIndex = e;

			if (e) {
				this.getLayerData();
				this.layerVal = '全部';
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			} else {
				this.layerData = [{ name: '全部', id: '' }];
				this.layerVal = '全部';
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			}
		},
		// 获取层下拉框数据
		getLayerData() {
			let needId = this.floorData[this.floorVal].id;
			this.$get(
				'/api/floor/getFloor/' + needId,
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							res.data[0].id = '';
							this.layerData = res.data;
						} else {
							this.layerData = [{ name: '全部', id: '' }];
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 监听层选择
		layerChange(e) {
			this.newSelectLayerIndex = e;

			if (e) {
				this.getRoomData();
				this.roomVal = '全部';
			} else {
				this.roomVal = '全部';
				this.roomData = [{ name: '全部', id: '' }];
			}
		},
		// 监听房选择
		roomChange(e) {
			this.newSelectRoomIndex = e;
		},
		// 获取房间下拉框数据
		getRoomData() {
			// let layerVal = this.layerVal == '全部' ? '' : this.layerVal;
			this.$get(
				'/api/room/getRoom/' + this.layerData[this.layerVal].id,
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							res.data[0].id = '';
							this.roomData = res.data;
						} else {
							this.roomData = [{ name: '全部', id: '' }];
						}
					} else {
						this.$message.error(res.msg);
						this.roomData = [];
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 筛选按钮
		screen() {
			this.getTableData();
		},
		// 筛选页面数据
		btnClick(val, date, num, type) {
			if (type == '1') {
				this.selectDateType = type
			} else if (type == '7') {
				this.selectDateType = type
			} else if (type == '3') {
				this.selectDateType = type
			} else {

			}
			this.activeType = val;
			this.activeDate = date;
			if (this.activeType > 2) {
				this.columns = this.dynamicMoreColumns;
				this.activeDate = this.activeDates[0];
			} else {
				this.columns = this.dynamicColumns;
			}
			this.getTableData();
		},
		btnClickNew(val, date, num, type) {
			if (type == '1') {
				this.selectDateType = type
			} else if (type == '7') {
				this.selectDateType = type
			} else if (type == '30') {
				this.selectDateType = type
			} else {

			}
			this.activeType = val;
			this.activeDate = date;
			if (this.activeType > 2) {
				this.columns = this.dynamicMoreColumns;
				this.activeDate = '';
			} else {
				this.columns = this.dynamicColumns;
			}
			this.getTableData();
		},
		changePageToData(path) {
			console.log(path);
			// this.$router.push('/dean/' + path);
			const { href } = this.$router.resolve({
				name: 'router-name',
				query: { id: 1 },
			});

			window.open(href, '_blank');
		},
		// 查看详情
		details(scope) {
			console.log(scope);
			this.$refs.healthy.details({
				// recordsData: scope,
				sn: scope.sn,
				bedId: scope.bedId,
				bedName: scope.bedName,
				activeType: this.activeType,
				activeDate: this.activeType == 3 || this.activeType == 4 ? this.convertChineseDateToISO(this.showActiveDate) : this.activeDate,
			});
		},
		// 年月日转YYYY-MM-DD
		convertChineseDateToISO(dateStr) {
			if (!dateStr) {
				dateStr = this.getCurrentDate();
			}
			if (dateStr && dateStr.length > 0 && dateStr.indexOf('年') < 0) {
				const currentDate = new Date();
				const currentYear = currentDate.getFullYear();
				dateStr = currentYear + '年' + dateStr;
			}
			
			// 使用正则表达式提取年、月、日
			const regex = /(\d{4})年(\d{1,2})月(\d{1,2})日/;
			const match = dateStr.match(regex);
			
			// 验证输入格式是否正确
			if (!match) {
					throw new Error("日期格式不正确，请使用XXXX年XX月XX日格式");
			}
			
			const year = match[1];
			// 确保月份和日期为两位数，不足的前面补0
			const month = String(match[2]).padStart(2, '0');
			const day = String(match[3]).padStart(2, '0');
			
			// 组合成yyyy-mm-dd格式
			return `${year}-${month}-${day}`;
		},

		// 获取单天详情数据

		// 二维码气泡
		QRCodeBtn(num, scope) {
			console.log(scope);
			if (scope.popoverVisible) {
				return;
			}
			let param = {
				baseUrl: '1',
				bedId: scope.bedId,
				type: this.activeType, // 1-昨天 2-前天 3-7天 4-30天
				date: this.activeDate,
			};
			this.loading1 = false;
			this.$get('/api/health/shareV1', param, (res) => {
				if (res.code == 0) {
					this.shareUrl = res.msg;
					// console.log(this.shareUrl);
				}
			});
			this.$nextTick(function () {
				this.bindQRCode1();
			});
		},
		// 分享
		shareBtn(scope) {
			console.log(scope)
			if (this.popoverVisible) {
				return;
			}


			let baseUrl = this.$store.state.baseUrl;
			let activeType = 1; //1日 2周 3月 4三月或六月
			if (this.activeType == 1) {
				activeType = 1;
			} else if (this.activeType == 3) {
				activeType = 2;
			} else if (this.activeType == 4) {
				activeType = 3;
			}
			let allParam =
				"?bedId=" +
				scope.bedId +
				"&activeType=" +
				activeType +
				"&date=" +
				this.activeDate;
			this.shareUrl = baseUrl + "/h5/#/index" + allParam;
			console.log(this.shareUrl);
			this.$nextTick(function () {
				this.bindQRCode2();
			});
			// let param = {
			//   baseUrl: '1',
			//   bedId: this.typeId,
			//   type: this.activeType, // 1-昨天 2-前天 3-7天 4-30天
			//   date: this.activeDate,
			// };

			// this.$get('/api/health/shareV1', param, (res) => {
			//   if (res.code == 0) {
			//     this.shareUrl = res.msg;
			//   }
			// });
			// this.$nextTick(function() {
			//   this.bindQRCode2();
			// });

		},
		// 生成二维码
		bindQRCode1: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDiv, {
					text: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: '#333333', //二维码颜色
					colorLight: '#ffffff', //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading1 = true;
			}, 1000);
		},
		bindQRCode2: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDiv, {
					text: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: '#333333', //二维码颜色
					colorLight: '#ffffff', //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading = false;
			}, 1000);

			setTimeout(() => {
				var shareP = document.getElementsByClassName('el-popover')[0];
				this.popoverTop =
					parseInt(shareP.style.top.replace('px', '')) + this.scrollTop;
			}, 0);
		},
		// 导出
		exportData() {
			var st = '';
			if (this.activeType == 1 || this.activeType == 2) st = this.activeDate;
			else if (this.activeType == 3) st = this.activeDates[6];
			else st = this.activeDates[29];
			let param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				startTime: st,
				endTime: this.activeDate,
				type: this.activeType, // 日期
				buildingId: this.floorVal, // 楼id
				floorId: this.layerVal == '全部' ? '' : this.layerVal, // 层id
				roomId: this.roomVal == '全部' ? '' : this.roomVal, // 房间id
				sortField: this.sortField,
				sortOrder: this.sortOrder,
			};
			if (this.activeType == 1 || this.activeType == 2) {
				this.$getExport('/api/health/exportv1', param, (res) => {
					const blob = new Blob([res]);
					//根据选择的是哪天大报告，去获取日期显示在名字上
					var fileName = this.activeDate + '健康数据.xlsx';
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				});
			} else {
				this.$getExport('/api/health/export', param, (res) => {
					const blob = new Blob([res]);
					//根据选择的是哪天大报告，去获取日期显示在名字上
					if (this.activeType == 3) {
						var fileName =
							this.getDay(-7, '-') +
							'-' +
							this.getDay(-1, '-') +
							'健康数据.xlsx';
					} else if (this.activeType == 4) {
						var fileName =
							this.getDay(-30, '-') +
							'-' +
							this.getDay(-1, '-') +
							'健康数据.xlsx';
					} else {
						var fileName = '健康数据.xlsx';
					}
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				});
			}
		},
		//获取日期
		getDay(num, str) {
			var today = new Date();
			var nowTime = today.getTime();
			var ms = 24 * 3600 * 1000 * num;
			today.setTime(parseInt(nowTime + ms));
			var oYear = today.getFullYear();
			var oMoth = (today.getMonth() + 1).toString();
			if (oMoth.length <= 1) oMoth = '0' + oMoth;
			var oDay = today.getDate().toString();
			if (oDay.length <= 1) oDay = '0' + oDay;
			return oYear + str + oMoth + str + oDay;
		},
		// 获取日历接口
		getHealthPageV1All() {
			let param2 = {
				bedId: this.typeId, // 当前页
			};
			this.$get(
				'/api/health/getHealthPageV1All',
				param2,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.effeDatesData = res.data.data;
							// console.log(this.effeDatesData);
							this.effeDates = [];
							var vdates = [];
							for (var i = 0; i < this.effeDatesData.length; i++) {
								for (var key in this.effeDatesData[i]) {
									if (key != 'reason') {
										vdates.push(key);
									}
								}
								if (this.effeDatesData[i].reason === '数据解析成功') {
									for (var key in this.effeDatesData[i]) {
										if (key != 'reason') {
											this.effeDates.push(key);
										}
									}
								}
							}
							this.invalidDates = [];
							for (var i = 0; i < this.activeDates.length; i++) {
								if (!vdates.includes(this.activeDates[i])) {
									this.invalidDates.push(this.activeDates[i]);
								}
							}
							// console.log("##", this.invalidDates);
							// console.log(this.effeDates);
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					//console.log(err);
					this.spinning = false;
					// this.$message.error('服务端发生异常');
				}
			);
		},
		getDayData(value) {
			for (var i = 0; i < this.effeDates.length; i++) {
				var m = parseInt(this.effeDates[i].slice(5, 7)) - 1;
				var d = parseInt(this.effeDates[i].slice(8, 10));
				if (value.month() == m && value.date() == d) return true;
			}
		},
	},
};
</script>
		

<!-- 1. 组件内样式：scoped SCSS（仅作用于当前组件） -->
<style lang="scss" scoped>
// 基础容器样式
.main {
  width: 1200px;
  margin: 30px auto 0;
  padding-bottom: 50px;
}

// 卡片样式
.main-card {
  background: #ECF0F3;
  box-shadow: 10px 10px 30px 0px #D1D9E6, -10px -10px 30px 0px #FFFFFF;
  border-radius: 20px;
  height: 700px;
  padding: 20px;
	padding-bottom: 0px;
	display: flex;
	flex-direction: column;

  ::v-deep .ant-card-body {
    padding: 0;
  }
}

// 标题区域样式
.health-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  // 主标题
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: rgba(31, 38, 53, 1);
    line-height: 24px;
  }

  // 搜索结果区域
  .search-result {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: rgba(31, 38, 53, 1);
    line-height: 24px;

    .search-count {
      color: rgba(74, 124, 232, 1);
    }

    // 返回按钮
    .back-btn {
      width: 66px;
      height: 30px;
      background: rgba(74, 124, 232, 0.15);
      border-radius: 20px;
      display: flex;
      align-items: center;
      margin-left: 10px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin: 0 2px 0 10px;
      }

      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #497AE5;
        line-height: 20px;
      }
    }
  }

  // 操作按钮区域（当日/累计数据）
  .operation-btns {
    display: flex;
    gap: 10px;

		.measure_tip {
			display: flex;
			background: #F5F7F9;
			border: 1px solid #E5EAEE;
			backdrop-filter: blur(8px);
			border-radius: 4px;
			align-items: center;
			padding-left: 15px;
			padding-right: 15px;
			margin-right: 5px;
			.measure_tip-arrow {
				width: 6px;
				height: 10px;
				position: absolute;
				right: -5px;
			}
			.measure_tip-item {
				display: flex;
				align-items: center;
				.measure_tip-item-img {
					width: 16px;
					height: 16px;
				}
				span {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #5E6779;
					line-height: 20px;
				}
				.text_color {
					color: rgba(74, 124, 232, 1);
				}
			}
			.measure_tip-line {
				width: 1px;
				height: 20px;
				background: #D5DADF;
				margin-left: 15px;
				margin-right: 15px;
			}
		}

    router-link {
      display: flex;
      align-items: flex-start;
    }
  }
}

// 分割线
.divider {
  height: 1px;
  border-bottom: 1px solid rgba(31, 38, 53, 0.05);
  margin-bottom: 15px;
}

// 顶部筛选区域（楼/层/房 + 搜索/日期）
.topList {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  // 左侧：楼/层/房筛选
  .topleft {
    display: flex;
    align-items: center;
    gap: 20px;

    .group {
      display: flex;
      align-items: center;
      gap: 8px;

      .group-label {
        font-size: 14px;
        color: #5E6779;
        white-space: nowrap;
      }

      .my-a-select {
        width: 130px;

        ::v-deep .ant-select-selection--single {
          height: 40px;
					// box-shadow: 0 0 0 1px red;

          .ant-select-selection__rendered {
            line-height: 38px;
          }
        }
      }
    }
  }

  // 右侧：搜索 + 日期 + 时间按钮
  .topright {
    .saiBtn {
      display: flex;
      align-items: center;
      gap: 15px;
    }
  }

	.dateBtn {
			background: #ECF0F3 !important;
	}
}

// 搜索框样式
.searchBedNameInputContent {
  display: flex;
  align-items: center;
  padding: 0 15px;
  border: 1px solid rgba(94, 103, 121, 0.2);
  border-radius: 20px;
  gap: 5px;

  .searchBedNameInput {
    width: 120px;
		height: 38px;
    border: none;
    outline: none;
    background: transparent;
    caret-color: rgba(74, 124, 232, 1);
    color: rgba(94, 103, 121, 1);

    &::placeholder {
      color: rgba(94, 103, 121, 0.3);
    }
  }

  .searchBedNameInputContentSearchImage {
    width: 16px;
    height: 16px;
    background: url("../../assets/icon_health_data_search_input_icon_1.png") no-repeat center;
    background-size: cover;
  }
}

// 搜索框hover状态
.searchBedNameInputContent_hover {
  background: rgba(74, 124, 232, 0.1);
  border-color: rgba(74, 124, 232, 0.3) !important;

  .searchBedNameInput {
    &::placeholder {
      color: rgba(74, 124, 232, 0.3);
    }
  }

  .searchBedNameInputContentSearchImage {
    background-image: url("../../assets/icon_health_data_search_input_icon_2.png");
  }
}

// 搜索框focus状态
.searchBedNameInputContent_edit {
  border-color: rgba(74, 124, 232, 1) !important;
  background: #FFFFFF;
}

// 日期选择器样式
.my-select-date {
  display: flex;
  position: relative;

  .my-select-date-input {
    display: flex;
    align-items: center;
    padding: 0 15px;
    border-radius: 20px;
    height: 38px;
    gap: 10px;

    .my-select-date-input-text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
    }

    .my-select-date-input-img {
      width: 16px;
      height: 16px;
    }
  }

  // 隐藏Element日期选择器原生输入框，用自定义样式覆盖
  .my-el-date-picker {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    z-index: 1;
  }
}

// 日期选择器默认状态
.my-select-date-1 {
  .my-select-date-input {
    background: #ECF0F3;
    border: 1px solid rgba(94, 103, 121, 0.2);

    .my-select-date-input-text {
      color: rgba(94, 103, 121, 1);
    }

    .my-select-date-input-img {
      background: url("../../assets/icon_common_select_date_icon_1.png") no-repeat center;
      background-size: cover;
    }
  }
}

// 日期选择器激活状态
.my-select-date-2 {
  .my-select-date-input {
    background: rgba(74, 124, 232, 0.1);
    border: 1px solid rgba(74, 124, 232, 0.3);

    .my-select-date-input-text {
      color: rgba(74, 124, 232, 1);
    }

    .my-select-date-input-img {
      background: url("../../assets/icon_common_select_date_icon_2.png") no-repeat center;
      background-size: cover;
    }
  }
}

// 时间筛选按钮（过去7天/30天）
.hoverBtns {
  padding: 9px 12px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  transition: all 0.3s;
	margin-right: 0px;
}

.hoverBtns:hover {
	color: #4A7CE8 !important;
	background: rgba(74,124,232,0.1) !important;
	border: 1px solid rgba(74,124,232,0.3) !important;
}

.hoverBtns.on {
  color: #5E6779;
	background: #ffffff;
	border: 1px solid #d9d9d9;
}

.hoverBtns.actives {
  color: #4A7CE8 !important;
	background: rgba(74,124,232,0.1) !important;
	border: 1px solid rgba(74,124,232,0.3) !important;
}

// 表格操作列样式
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  .tableBtn {
    color: #4A7CE8;
    cursor: pointer;
    text-decoration: underline;
  }

  .share {
    .imgIcon {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
}

// 二维码弹窗样式
.shareBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;

  p {
    margin: 8px 0 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #5E6779;
  }
}

// 表格空状态
.empty-state {
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;

  img {
    width: 107px;
    height: 107px;
  }

  div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #A4ABB6;
    line-height: 20px;
  }
}

// 分页容器
.old_healthy-pagination-container {
 margin-top: 15px;
 height: 50px;

  ::v-deep .ant-pagination {
    text-align: center;
  }
}

// 未订购提示
.table-empty {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #A4ABB6;
  font-size: 14px;
  line-height: 20px;
}

// Ant Design 表格样式穿透（保持原有视觉）
::v-deep {
  // 下拉选择框样式穿透
  .my-a-select-normal .ant-select-selection {
    background: #ECF0F3;
    border: 1px solid rgba(94, 103, 121, 0.2);
    border-radius: 20px;

    .ant-select-selection-selected-value {
      color: rgba(94, 103, 121, 1);
    }
  }

  .my-a-select-high-light .ant-select-selection {
    background: rgba(74, 124, 232, 0.1);
    border-color: rgba(74, 124, 232, 0.3);
    border-radius: 20px;

    .ant-select-selection-selected-value {
      color: #4A7CE8;
    }
  }

  // 分页样式穿透
  .ant-pagination-item {
    background: #ECF0F3;
    box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
    border-radius: 8px;
    border: 1px solid #ECF0F3;

    &:hover {
      background: #DFE8FC;
      border-color: #DFE8FC;
    }

    &.ant-pagination-item-active {
      border-color: rgba(74, 124, 232, 0.5);
    }
  }

  .ant-pagination-item-link {
    background: #ECF0F3;
    box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
    border-radius: 8px;
    border: none;

    &:hover {
      background: #DFE8FC;
      border-color: #DFE8FC;
    }

    &.ant-pagination-disabled {
      background: #ECF0F3;
      border: 1px solid rgba(202, 205, 217, 0.5);
      box-shadow: none;
    }
  }
}


::v-deep .ant-select-selection--single {
    height: 40px;
    .ant-select-selection__rendered {
        line-height: 38px;
    }
}

::v-deep .ant-select-selection {
    background: #ECF0F3;
    border-radius: 20px;
    border: 1px solid rgba(94,103,121,0.2);
    box-shadow: unset !important;
}

::v-deep .ant-select-selection:hover {
    background: rgba(74,124,232,0.1);
    border-radius: 20px;
    border: 1px solid rgba(74,124,232,0.3);
    box-shadow: unset !important;
}

::v-deep .ant-select-selection:active {
    background: rgba(74,124,232,0.1);
    border-radius: 20px;
    border: 1px solid rgba(74,124,232,0.3);
    box-shadow: unset !important;
}


::v-deep .ant-select-selection:focus {
    background: rgba(74,124,232,0.1);
    border-radius: 20px;
    border: 1px solid rgba(74,124,232,0.3);
    box-shadow: unset !important;
}

::v-deep .ant-select-open {
    .ant-select-selection {
        background: rgba(74,124,232,0.1) !important;
        border: 1px solid rgba(74,124,232,0.3) !important;
        .ant-select-selection-selected-value {
            color: rgba(74, 124, 232, 1) !important;
        }
        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
    .ant-select-selection:hover {
        background: rgba(74,124,232,0.1) !important;
        border: 1px solid rgba(74,124,232,0.3) !important;
        .ant-select-selection-selected-value {
            color: rgba(74, 124, 232, 1) !important;
        }
        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
}

::v-deep .my-a-select-normal {
    .ant-select-selection {
        background: #ECF0F3;
        border: 1px solid rgba(94,103,121,0.2);
        .ant-select-selection-selected-value {
            color: rgba(94, 103, 121, 1);
        }
        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
    .ant-select-selection:hover {
        background: rgba(74,124,232,0.1);
        border: 1px solid rgba(74,124,232,0.3);
        .ant-select-selection-selected-value {
            color: rgba(74, 124, 232, 1);
        }

        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
}

::v-deep .my-a-select-high-light {
    .ant-select-selection {
        background: rgba(74,124,232,0.1);
        border: 1px solid rgba(74,124,232,0.3);
        .ant-select-selection-selected-value {
            color: rgba(74, 124, 232, 1);
        }
        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
    .ant-select-selection:hover {
        background: rgba(74,124,232,0.1);
        border: 1px solid rgba(74,124,232,0.3);
        .ant-select-selection-selected-value {
            color: rgba(74, 124, 232, 1);
        }
        .ant-select-arrow {
            color: rgba(31, 38, 53, 0.5);
        }
    }
}

</style>

<!-- 2. 全局样式：作用于第三方组件（Element/Ant Design），不污染其他组件 -->
<style lang="scss">
.my-el-date-picker-popper {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(94, 103, 121, 0.15);
  border: none;

  // 隐藏弹窗箭头
  .popper__arrow {
    opacity: 0 !important;
  }

  // 日期表格样式
  .el-date-table {
    th {
      color: rgba(94, 103, 121, 0.5);
      font-weight: 400;
    }

    td {
      &.current:not(.disabled) span {
        background: rgba(74, 124, 232, 1) !important;
        border-radius: 50%;
      }

      &.available:hover span {
        background: rgba(74, 124, 232, 0.1) !important;
        border-radius: 50%;
      }

      &.next-month,
      &.prev-month {
        color: rgba(94, 103, 121, 0.14);
      }

      &.disabled div {
        background: transparent !important;
        color: rgba(94, 103, 121, 0.14) !important;
      }
    }
  }
}

// Ant Design 下拉菜单全局样式（仅作用于当前组件的下拉）
.ant-select-dropdown {
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(94, 103, 121, 0.2);
  border-radius: 8px;
  border: none;

  .ant-select-dropdown-menu-item {
    font-weight: 400 !important;
    padding: 8px 16px;

    &:hover:not(.ant-select-dropdown-menu-item-disabled) {
      background: rgba(74, 124, 232, 0.1) !important;
      color: #4A7CE8 !important;
    }

    &.ant-select-dropdown-menu-item-selected {
      background: rgba(74, 124, 232, 0.1) !important;
      color: #4A7CE8 !important;
    }

    &.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
      background: transparent !important;
    }
  }
}

// Element UI 弹窗样式
.share-popover {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(94, 103, 121, 0.15);
  border: none;
  
  .el-popover__title {
    display: none;
  }
}

.old_healthy_table_container {
    overflow: hidden;

		.el-table__body .el-table__row.hover-row td{
				background-color: rgba(244, 246, 254, 1) !important
		}
		.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
			background: rgba(245, 247, 249, 1);
		}

		.el-table__body-wrapper {
			background: rgba(236, 240, 243, 1);
		}

		.el-table__fixed-right {
			box-shadow: 0 0 10px rgba(236, 240, 243, 1);
		}
		.el-table__fixed-right-patch {
			background: rgba(245, 247, 249, 1);
		}

}

.old_healthy_table_container {
  // 处理表格整体 hover 效果
  .old_healthy_table {
    // 普通列行 hover 样式
    &:hover > tbody > tr:hover > td {
      background-color: #dae3f1 !important; // 自定义hover背景色
    }

    // 固定列行 hover 样式（解决fixed列单独渲染导致的样式隔离问题）
    .el-table__fixed-right {
      .el-table__fixed-body-wrapper {
        tbody tr:hover td {
          background-color: #dae3f1 !important; // 与普通列保持一致
        }
      }
    }

    // 修复固定列与普通列hover颜色不一致问题
    .el-table__body tr.hover-row > td,
    .el-table__body tr:hover > td {
      background-color: #dae3f1 !important;
    }

    // 处理固定列边缘可能出现的缝隙
    .el-table__fixed-right {
      box-shadow: 0 0 10px rgba(236, 240, 243, 1);
    }
  }
}


</style>